import React from "react";
import "./index.scss";

const BookingFlow = ({ currentStep }) => {
  const steps = window.constant.BOOKING_FLOW_STEPS || [];

  return (
    <div className="booking-flow">
      {steps.map((step, index) => {
        return (
          <div key={index} className={`step ${currentStep >= step.id ? "active" : ""}`}>
            <span className="name">
              <span className="step-number">{step.id}</span>
              {step.name}
            </span>
            <span className="icon">
              <img src={currentStep >= step.id ? step.activeIcon : step.icon} alt={step.name} />
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default BookingFlow;
